import {
    MessageTooltip,
    pxToRem,
    useAppDisplayModeContext,
} from '@archipro-design/aria';
import React from 'react';
import { useIsFollowSelectorOpen } from '~/modules/moodboards/context/FollowSelectorContext';

interface HoverActionArticleProps {
    label: string;
    action: JSX.Element;
    disabled?: boolean;
}

export const HoverActionArticle = ({
    label,
    action,
    disabled = false,
}: HoverActionArticleProps) => {
    const [tooltipEnabled, setTooltipEnabled] = React.useState(false);
    const { mobile: isMobile } = useAppDisplayModeContext();
    const isPopoverOpen = useIsFollowSelectorOpen();

    // Reset tooltipEnabled when the popover closes. The onMouseLeave handler
    // skips clearing tooltipEnabled while the popover is open, so without this
    // effect the tooltip would reappear once the popover closes even though the
    // cursor is no longer over the trigger.
    React.useEffect(() => {
        if (!isPopoverOpen) {
            setTooltipEnabled(false);
        }
    }, [isPopoverOpen]);

    if (isMobile) {
        return action;
    }

    // Hide tooltip when the FollowSelector popover is open to prevent
    // the tooltip from flashing and the heart icon from disappearing.
    const showTooltip = tooltipEnabled && !isPopoverOpen;

    //todo remove conditional content render when ssr issue with northstar Tooltip has been resolved
    return (
        <MessageTooltip
            trigger={
                <span
                    onMouseEnter={() => setTooltipEnabled(true)}
                    onMouseLeave={() => {
                        if (!isPopoverOpen) {
                            setTooltipEnabled(false);
                        }
                    }}
                    style={disabled ? { pointerEvents: 'none' } : undefined}
                >
                    {action}
                </span>
            }
            content={
                showTooltip
                    ? {
                          children: label,
                          size: 16,
                          padding: 16,
                          variables: { maxWidth: pxToRem(220) },
                      }
                    : null
            }
            position="below"
            offset={[-1, 12]}
        />
    );
};
